import { render, staticRenderFns } from "./NewRecipe.vue?vue&type=template&id=73372ada&"
import script from "./NewRecipe.vue?vue&type=script&lang=js&"
export * from "./NewRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports